import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=a61f9924"
import script from "./CalendarWidget.vue?vue&type=script&lang=ts"
export * from "./CalendarWidget.vue?vue&type=script&lang=ts"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&id=a61f9924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports